import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ShipmentServiceService {

  constructor(private readonly http: HttpClient) { }

  private readonly selectedOrgSubject = new BehaviorSubject<any>(null);
  selectedOrg$ = this.selectedOrgSubject.asObservable();

  private readonly filterSubject = new BehaviorSubject<any>(null);
  filter$ = this.filterSubject.asObservable();

  setSelectedOrg(obj: any) {
    this.selectedOrgSubject.next(obj);
  }

  getSelectedOrg() {
    return this.selectedOrgSubject.getValue();
  }

  setFilter(obj: any) {
    this.filterSubject.next(obj);
  }

  getFilter() {
    return this.filterSubject.getValue();
  }

  getCustomers(companyId:any,params: any): Observable<any> {
    let url = environment.API_URL + `/v1/customers/${companyId}`;
    return this.http.get(url, { params });
  }

  getBuyers(companyId:any,params: any): Observable<any> {
    let url = `${environment.API_URL}/v1/buyers/${companyId}`;
    return this.http.get(url, { params });
  }

  getCustomersCount(companyId:any,params: any): Observable<any> {
    let url = environment.API_URL + `/v1/customers/count/${companyId}`;
    return this.http.get(url, { params });
  }

  getBuyersCount(companyId:any,params: any): Observable<any> {
    let url = environment.API_URL + `/v1/buyers/count/${companyId}`;
    return this.http.get(url, { params });
  }

  createCustomer(payload: any,companyId:any): Observable<any> {
    let url = environment.API_URL + `/v1/customers/${companyId}`;
    return this.http.post(url, payload);
  }

  editCustomer(payload: any,companyId:any,id : any): Observable<any> {
    let url = environment.API_URL + `/v1/customers/update/${companyId}/` + id;
    return this.http.put(url, payload)
  }

  deleteCustomer(companyId:any,id: any): Observable<any> {
    let url = environment.API_URL + `/v1/customers/delete/${companyId}/` + id;
    return this.http.delete(url);
  }

  createBuyer(payload: any,companyId:any): Observable<any> {
    let url = environment.API_URL + `/v1/buyers/${companyId}`;
    return this.http.post(url, payload);
  }

  editBuyer(payload: any,companyId:any,id : any): Observable<any> {
    let url = environment.API_URL + `/v1/buyers/update/${companyId}/` + id;
    return this.http.put(url, payload)
  }

  deleteBuyer(companyId:any,id: any): Observable<any> {
    let url = environment.API_URL + `/v1/buyers/delete/${companyId}/` + id;
    return this.http.delete(url);
  }

  uploadSheet(file: any,companyId:any,type: string,transporterId?:any) {
    let formData = new FormData();
    formData.append('file', file);
    let url = `${environment.API_URL}/v1/shipment/upload/${companyId}/?type=${type}&transporterId=${transporterId}`;
    return this.http.post(url, formData);
  }

  getSuppliersList(companyId:any,params: any): Observable<any> {
    let url = environment.API_URL + `/v1/suppliers/${companyId}`;
    return this.http.get(url, { params});
  }

  getSuppliersCount(companyId:any,params: any) {
    let url = environment.API_URL + `/v1/suppliers/count/${companyId}`;
    return this.http.get(url, { params});
  }

  saveSuppliers(payload: any,companyId:any) {
    let url = environment.API_URL + `/v1/suppliers/${companyId}`;
    return this.http.post(url, payload);
  }

  editSupplier(payload: any,companyId:any,id:any){
    let url = environment.API_URL + `/v1/suppliers/update/${companyId}/` + id;
    return this.http.put(url, payload);
  }

  deleteSupplier(companyId:any,id: any): Observable<any> {
    let url = environment.API_URL + `/v1/suppliers/delete/${companyId}/` + id;
    return this.http.delete(url);
  }

  getTransportersList(companyId:any,params: any): Observable<any> {
    let url = environment.API_URL + `/v1/transporters/${companyId}`;
    return this.http.get(url, { params });
  }

  getTransportersCount(companyId:any,params: any) {
    let url = environment.API_URL + `/v1/transporters/count/${companyId}`;
    return this.http.get(url, { params });
  }

  saveTransporter(payload: any,companyId:any) {
    let url = environment.API_URL + `/v1/transporters/${companyId}`;
    return this.http.post(url, payload);
  }

  editTransporter(payload: any,companyId:any,id: any) {
    let url = environment.API_URL + `/v1/transporters/update/${companyId}/` + id;
    return this.http.put(url, payload);
  }

  deleteTransporter(companyId:any,id: any): Observable<any> {
    let url = environment.API_URL + `/v1/transporters/delete/${companyId}/` + id;
    return this.http.delete(url);
  }

  generateUniqueId(payload: any): Observable<any> {
    let url = environment.API_URL + `/v1/inbound-material/uniqueId`;
    return this.http.post(url, payload);
  }

  createInboundImport(payload: any, isDuplicate: boolean = false): Observable<any> {
  let url = `${environment.API_URL}/v1/inbound-material/import?isDuplicate=${isDuplicate}`;
    return this.http.post(url, payload);
  }

  createInboundDomestic(payload: any, isDuplicate: boolean = false): Observable<any> {
  let url = `${environment.API_URL}/v1/inbound-material/domestic?isDuplicate=${isDuplicate}`;
    return this.http.post(url, payload);
  }

  editInbound(id : any,payload : any, isDuplicate: boolean = false) {
  let url = `${environment.API_URL}/v1/inbound-material/${id}?isDuplicate=${isDuplicate}`;
    return this.http.put(url, payload);
  }

  getMaterialList(params:any, companyId: any) {
    let url = `${environment.API_URL}/v1/inbound-material/list/${companyId}`;
    return this.http.get(url,{ params });
  }

  getSubMaterialList(id:any,params:any) {
    let url = environment.API_URL + `/v1/inbound-material/`+id+`/material`;
    return this.http.get(url,{ params});
  }

  getSubOutBoundMaterialList(id:any,params:any) {
    let url = environment.API_URL + `/v1/outbound-material/`+id+`/material`;
    return this.http.get(url,{ params});
  }

  createOutbound(payload: any): Observable<any> {
    let url = environment.API_URL + `/v1/outbound-material`;
    return this.http.post(url, payload);
  }

  outboundTranporters(companyId: any,params?: any): Observable<any> {
    let url = environment.API_URL + `/v1/outbound_transporters/${companyId}`;
    return this.http.get(url, { params });
  }

  getOutboundTransportersCount(companyId: any,params: any): Observable<any> {
    let url = environment.API_URL + `/v1/outbound_transporters/count/${companyId}`;
    return this.http.get(url, { params });
  }

  saveOutboundTransporter(payload: any,companyId:any) {
    let url = environment.API_URL + `/v1/outbound_transporters/${companyId}`;
    return this.http.post(url, payload);
  }

  editOutboundTransporter(payload: any,companyId:any, id: any) {
    let url = environment.API_URL + `/v1/outbound_transporters/update/${companyId}/` + id;
    return this.http.put(url, payload);
  }

  deleteOutboundTransporter(companyId:any,id: any): Observable<any> {
    let url = environment.API_URL + `/v1/outbound_transporters/delete/${companyId}/` + id;
    return this.http.delete(url);
  }

  createOutboundExport(payload: any, isDuplicate: boolean = false): Observable<any> {
    let url = environment.API_URL + `/v1/outbound-material/export?isDuplicate=${isDuplicate}`;
    return this.http.post(url, payload);
  }

  createOutboundDomestic(payload: any, isDuplicate: boolean = false): Observable<any> {
    let url = environment.API_URL + `/v1/outbound-material/domestic?isDuplicate=${isDuplicate}`;
    return this.http.post(url, payload);
  }

  getShipmentSubFolders(id: any,params : any): Observable<any> {
    let url = environment.API_URL + `/v1/shipment-document/get-shipment-sub-folders/`+id;
    return this.http.get(url, { params });
  }

  downloadSheet(companyId:any,type: string,transporterId?:any): Observable<any> {
    let url = `${environment.API_URL}/v1/shipment/exportsheet/${companyId}/?shipmentType=${type}&transporterId=${transporterId}`;
    return this.http.post(url,{}, { responseType: 'blob', observe: 'response' });
  }

  downloadTemplate(type: string,transporterId?:any): Observable<any> {
    let url = `${environment.API_URL}/v1/shipment/samplesheet?shipmentType=${type}&transporterId=${transporterId}`;
    return this.http.post(url,{}, { responseType: 'blob', observe: 'response' });
  }

  getSheetDownload(params: any,companyId: any, materialType:any) {
    let url = `${environment.API_URL}/v1/${materialType}/list/${companyId}`;
    if (params) {
      params = { ...params, download: true };
    }
    return this.http.get(url, { params, responseType: 'blob', observe: 'response'});
  }


  uploadFile(file: any, _id: any, company: any, parentDirectory: any, type: string) {
    let formData = new FormData();
    formData.append('file', file);
    let url = `${environment.API_URL}/v1/shipment-document/${_id}/${company}/${parentDirectory}/upload`;
    if (type) {
      url += `?type=${type}`;
    }
    return this.http.post(url, formData);
  }

  getInboundCount(params: any,id : any): Observable<any> {
    let url = environment.API_URL + `/v1/inbound-material/list-count/`+id;
    return this.http.get(url, { params });
  }

  getOutboundCount(params: any,id : any): Observable<any> {
    let url = environment.API_URL + `/v1/outbound-material/count/`+id;
    return this.http.get(url, { params });
  }

  getMaterialOutboundList(params:any, id: any): Observable<any>  {
    let url = `${environment.API_URL}/v1/outbound-material/list/`+id;
    return this.http.get(url,{ params });
  }


  getFileThumbnail(companyId:any,documentId: any, payload: any): Observable<Blob> {
    let url = `${environment.API_URL}/v1/digilocker/document/${companyId}/${documentId}/export`;
    return this.http.post(url, payload, { responseType: 'blob' });
  }


  getInboundLog(documentId:any,params: any = {}): Observable<any> {
    let url = `${environment.API_URL}/v1/digilocker/document/${documentId}/log`;
    return this.http.get(url,{params});
  }

  getFilesDetails(documentId: any): Observable<any> {
    let url = `${environment.API_URL}/v1/digilocker/${documentId}`;
    return this.http.get(url);
  }

  getUpdateHistory(materialId: any,params: any = {}): Observable<any> {
    let url = `${environment.API_URL}/v1/inbound-material/reasons/${materialId}`;
    return this.http.get(url,{params});
  }

  editInboundReasonsList(): Observable<any> {
    let url = environment.API_URL + '/v1/inbound-material/mismatch/reasons';
    return this.http.get(url);
  }

  editOutbound(id : any,payload : any, isDuplicate: boolean = false) {
    let url = environment.API_URL + `/v1/outbound-material/material-update/${id}?isDuplicate=${isDuplicate}`;
    return this.http.put(url, payload);
  }

  getOutboundMaterialList(id:any) {
    let url = environment.API_URL + `/v1/outbound-material/`+id+`/material`;
    return this.http.get(url);
  }

  addScrapMaterial(payload: any, isDuplicate: boolean = false): Observable<any> {
    let url = environment.API_URL + `/v1/scrap-material?isDuplicate=${isDuplicate}`;
    return this.http.post(url, payload);
  }

  getMaterialScrapList(params:any, id: any): Observable<any>  {
    let url = `${environment.API_URL}/v1/scrap-material/list/`+id;
    return this.http.get(url,{ params });
  }

  getSubScrapMaterialList(id:any,params:any) {
    let url = environment.API_URL + `/v1/scrap-material/`+id;
    return this.http.get(url,{ params});
  }

  editScrapBuyer(id : any,payload : any, isDuplicate: boolean = false) {
    let url = environment.API_URL + `/v1/scrap-material/material-update/${id}?isDuplicate=${isDuplicate}`;
    return this.http.put(url, payload);
  }

  getScrapCount(params: any,id : any): Observable<any> {
    let url = environment.API_URL + `/v1/scrap-material/count/`+id;
    return this.http.get(url, { params });
  }

  getCategories(companyId:any): Observable<any> {
    let url = environment.API_URL + `/v1/company-doc-types/material-doc-types/${companyId}`;
    return this.http.get(url);
  }

  getCountries(): Observable<any> {
    let url = environment.API_URL + `/v1/country-code`;
    return this.http.get(url);
  }

  fileHistoryLog(type: string): Observable<any> {
    let url = `${environment.API_URL}/v1/shipment/bp-logs?shipmentType=${type}`;
    return this.http.get(url);
  }

  subTransporterLog(type: string,transporterId: any): Observable<any> {
    let url = `${environment.API_URL}/v1/shipment/bp-logs?shipmentType=${type}&transporterId=${transporterId}`;
    return this.http.get(url);
  }

   getSubTransportersList(companyId:any,transporterId:any,params: any): Observable<any> {
    let url = environment.API_URL + `/v1/sub-transporters/${companyId}/${transporterId}`;
    return this.http.get(url, { params });
  }

  getSubTransportersCount(companyId:any,transporterId:any,params: any): Observable<any>{
    let url = environment.API_URL + `/v1/sub-transporters/count/${companyId}/${transporterId}`;
    return this.http.get(url, { params });
  }

  saveSubTransporter(payload: any,companyId:any,transporterId:any): Observable<any> {
    let url = environment.API_URL + `/v1/sub-transporters/${companyId}/${transporterId}`;
    return this.http.post(url, payload);
  }

  editSubTransporter(payload: any,companyId:any,subTransporterId: any,transporterId: any) : Observable<any>{
    let url = environment.API_URL + `/v1/sub-transporters/update/${companyId}/${subTransporterId}/${transporterId}`;
    return this.http.put(url, payload);
  }

  deleteSubTransporter(companyId:any,subTransporterId: any): Observable<any> {
    let url = environment.API_URL + `/v1/sub-transporters/delete/${companyId}/${subTransporterId}`;
    return this.http.delete(url);
  }

  getFreightForwardersList(companyId:any,params: any): Observable<any> {
    let url = environment.API_URL + `/v1/freight-forwarders/${companyId}`;
    return this.http.get(url, { params });
  }

  getFreightForwardersCount(companyId:any,params: any): Observable<any>{
    let url = environment.API_URL + `/v1/freight-forwarders/count/${companyId}`;
    return this.http.get(url, { params });
  }

  saveFreightForwarders(payload: any,companyId:any): Observable<any> {
    let url = environment.API_URL + `/v1/freight-forwarders/${companyId}`;
    return this.http.post(url, payload);
  }

  editFreightForwarders(payload: any,companyId:any,id: any) : Observable<any>{
    let url = environment.API_URL + `/v1/freight-forwarders/update/${companyId}/${id}`;
    return this.http.put(url, payload);
  }

  deleteFreightForwarders(companyId:any,id: any): Observable<any> {
    let url = environment.API_URL + `/v1/freight-forwarders/delete/${companyId}/${id}`;
    return this.http.delete(url);
  }

}
